import { defineNuxtRouteMiddleware, navigateTo, useCookie } from "nuxt/app"
// @ts-ignore
import { useStrapiUser } from "#imports";

export default defineNuxtRouteMiddleware((to, _from) => {
  const user = useStrapiUser()
  if (!user.value) {
    useCookie('redirect', { path: '/' }).value = to.fullPath
    return navigateTo('/')
  }
})
